var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE100"
    },
    points: "7.501,502.498 502.498,502.498 502.498,7.501 7.501,7.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA800"
    },
    points: "476.895,502.498 502.498,502.498 502.498,7.501 476.895,7.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "7.501,502.498 33.104,502.498 33.104,7.501 7.501,7.501  "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.499,511H7.501C2.806,511-1,507.194-1,502.499V7.501C-1,2.806,2.806-1,7.501-1h494.998C507.194-1,511,2.806,511,7.501 v494.998C511,507.194,507.194,511,502.499,511z M16.002,493.998h477.996V16.002H16.002V493.998z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.551,468.328c-42.334,0-76.777-34.442-76.777-76.777c0-4.695,3.807-8.501,8.501-8.501c4.695,0,8.501,3.806,8.501,8.501 c0,32.959,26.815,59.775,59.775,59.775s59.775-26.815,59.775-59.775s-26.815-59.775-59.775-59.775 c-42.334,0-76.777-34.442-76.777-76.777s34.442-76.776,76.777-76.776s76.777,34.442,76.777,76.777c0,4.695-3.806,8.501-8.501,8.501 c-4.695,0-8.501-3.806-8.501-8.501c0-32.96-26.815-59.775-59.775-59.775S331.776,222.04,331.776,255 c0,32.959,26.815,59.775,59.775,59.775c42.334,0,76.777,34.442,76.777,76.777S433.885,468.328,391.551,468.328z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.328,468.328c-42.334,0-76.777-34.442-76.777-76.777c0-4.695,3.806-8.501,8.501-8.501s8.501,3.806,8.501,8.501 c0,32.959,26.814,59.775,59.775,59.775s59.775-26.815,59.775-59.775V186.724c0-4.695,3.806-8.501,8.501-8.501 s8.501,3.806,8.501,8.501v204.826C289.103,433.885,254.662,468.328,212.328,468.328z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.b0e8ba7e.svg";
export { ForwardRef as ReactComponent };